import { useIntl } from "react-intl";

interface ChatFooterProps {
  view: "chat" | "draft";
  inputText: string;
  isRunning: boolean;
  textareaRef: React.RefObject<HTMLTextAreaElement>;
  onInputChange: (inputText: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  onKeyDown: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
}

export const ChatFooter = ({
  view,
  inputText,
  isRunning,
  textareaRef,
  onInputChange,
  onSubmit,
  onKeyDown,
}: ChatFooterProps) => {
  const intl = useIntl();

  return (
    <div className={`tcw-footer${view === "draft" ? " tcw-footer--hidden" : ""}`}>
      <form className="tcw-input-wrapper" onSubmit={onSubmit}>
        <textarea
          ref={textareaRef}
          className="tcw-input"
          rows={2}
          placeholder={intl.formatMessage({ id: "app.toolboxChat.input.placeholder" })}
          value={inputText}
          onChange={(e) => onInputChange(e.target.value)}
          onKeyDown={onKeyDown}
          disabled={isRunning}
          aria-label={intl.formatMessage({ id: "app.toolboxChat.input.ariaLabel" })}
        />
        <div className="tcw-send-wrapper">
          <button
            type="submit"
            className="tcw-send-btn"
            disabled={isRunning || !inputText.trim()}
            aria-label={intl.formatMessage({ id: "app.toolboxChat.send.ariaLabel" })}
          >
            <span className="svg-icon tcw-send-btn-icon"></span>
          </button>
        </div>
      </form>
      <p className="tcw-disclaimer">
        {intl.formatMessage({ id: "app.toolboxChat.disclaimer" })}
      </p>
    </div>
  );
};
